import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const OdataReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="odataReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="odataReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="odataReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="odataReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter connection key"
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="odataReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter parameterization"
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="odataReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter file format"
        error={errors?.format?.message}
      />
      <FormField
        controlId="odataReaderFormUrl"
        label="url"
        name="properties.url"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter OData endpoint URL"
        required
        error={errors?.properties?.url?.message}
      />
      <FormField
        controlId="odataReaderFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Select HTTP method"
        error={errors?.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="odataReaderFormHeaders"
        label="headers"
        name="properties.headers"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        placeholder="Enter headers"
        error={errors?.properties?.headers?.message}
        rows={10}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default OdataReaderForm;
